import { cargoReleaseCreateTypes } from './actionTypes';

//---------------------GET---------------------------------------

export const getCargoReleaseOptions = () => ({
  type: cargoReleaseCreateTypes.GET_FiltersCreateCR,
});

export const getCargoReleaseOptionsSuccess = (payload: any) => ({
  type: cargoReleaseCreateTypes.GET_FiltersCreateCR_SUCCESS,
  payload,
});

export const getCargoReleaseOptionsFail = (error: any) => ({
  type: cargoReleaseCreateTypes.GET_FiltersCreateCR_FAIL,
  payload: error,
});

//---------------------create-----------------------------------
export const CreateCargoRelease = (payload:any) => ({
  type: cargoReleaseCreateTypes.CREATE_CR,
  payload,
});

export const CreateCargoReleaseSuccess = (payload: any) => ({
  type: cargoReleaseCreateTypes.CREATE_CR_SUCCESS,
  payload,
});

export const CreateCargoReleaseFail = (error: any) => ({
  type: cargoReleaseCreateTypes.CREATE_CR_FAIL,
  payload: error,
});

//------------------------Get filters---------------------
export const getFiltersItemAggregation = () => ({
  type: cargoReleaseCreateTypes.GET_FiltersListItemAggregation,
});

export const getFiltersItemAggregationSuccess = (payload: any) => ({
  type: cargoReleaseCreateTypes.GET_FiltersListItemAggregation_SUCCESS,
  payload,
});

export const getFiltersItemAggregationFail = (error: any) => ({
  type: cargoReleaseCreateTypes.GET_FiltersListItemAggregation_FAIL,
  payload: error,
});
//-------------------Get items------------------------------------
export const getItemsAggregation = (payload: any) => ({
  type: cargoReleaseCreateTypes.GET_COMMODITY_DEFINITIONS,
  payload,
});

export const getItemsAggregationSuccess = (payload: any) => ({
  type: cargoReleaseCreateTypes.GET_COMMODITY_SUCCESS,
  payload,
});

export const getItemsAggregationFail = (error: any) => ({
  type: cargoReleaseCreateTypes.GET_COMMODITY_FAIL,
  payload: error,
});

//-------------------Get address------------------------------------
export const getAdressByEntity = (payload: any) => ({
  type: cargoReleaseCreateTypes.GET_ADDRESS_BY_ENTITY_NAME,
  payload,
});

export const getAdressByEntitySuccess = (payload: any) => ({
  type: cargoReleaseCreateTypes.GET_ADDRESS_BY_ENTITY_NAME_SUCCESS,
  payload,
});

export const getAdressByEntityFail = (error: any) => ({
  type: cargoReleaseCreateTypes.GET_ADDRESS_BY_ENTITY_NAME_FAIL,
  payload: error,
});

